var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-gallery",class:_vm.$mq},[(_vm.$config.gallery.display)?_c('gallery',{class:_vm.$mq,attrs:{"images":_vm.images,"index":_vm.index},on:{"close":_vm.close}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }